import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '../containers/Full.vue';
import MarketplaceContainer from '../containers/Marketplace.vue';
import MarketplacesCategoryContainer from '../containers/MarketplacesCategory.vue';

// PAGES
import Dashboard from '../pages/Dashboard.vue';
import Error404 from '../pages/Error404.vue';
import Error500 from '../pages/Error500.vue';
import Login from '../pages/Login.vue';
import MarketplacesCategories from '../pages/MarketplacesCategories.vue';
import MarketplacesCategory from '../pages/MarketplacesCategory.vue';
import MarketplacesCategoryTemplates from '../pages/MarketplacesCategoryTemplates.vue';
import Marketplaces from '../pages/Marketplaces.vue';
import Accounts from '../pages/Accounts.vue';
import CreateAccount from '../pages/AccountCreate.vue';
import EditAccount from '../pages/AccountEdit.vue';
import Users from '../pages/Users.vue';
import CreateUser from '../pages/UserCreate.vue';
import EditUser from '../pages/UserEdit.vue';
import MarketplaceMain from '../pages/MarketplaceMain.vue';
import MarketplaceCredentialFields from '../pages/MarketplaceCredentialFields.vue';
import MarketplaceFields from '../pages/MarketplaceFields.vue';
import MarketplaceTemplates from '../pages/MarketplaceTemplates.vue';
import ProductsColorsMaps from '../pages/ProductsColorsMaps.vue';
import ProductsSizesMaps from '../pages/ProductsSizesMaps.vue';
import CustomPlans from '../pages/CustomPlans.vue';
import CustomPlanEdit from '../pages/CustomPlanEdit.vue';
import CustomPlanCreate from '../pages/CustomPlanCreate.vue';
import DefaultPlans from '../pages/DefaultPlans.vue';
import DefaultPlanEdit from '../pages/DefaultPlanEdit.vue';
import DefaultPlanCreate from '../pages/DefaultPlanCreate.vue';
import InventoryLogs from '../pages/InventoryLogs.vue';
import OrderLogs from '../pages/OrderLogs.vue';
import InventoryLogsDetail from '../pages/InventoryLogsDetail.vue';
import OrderLogsDetail from '../pages/OrderLogsDetail.vue';
import UserTokenService from '../services/AdminsTokensService';
import AdminsService from '../services/AdminsService';

import UsersRoleModel from '../models/UsersRoleModel';

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'open active',
  mode: 'history',
  root: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Home',
      path: '/',
      redirect: '/dashboard',
      component: Full,
      meta: {
        auth: true,
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            auth: true,
            breadcrumbs: 'Dashboard',
            // authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
          },
        },
        {
          name: 'Marketplaces',
          path: 'marketplaces',
          component: {
            render(c) { return c('router-view'); },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Marketplaces',
            authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          },
          children: [
            {
              path: 'marketplaces',
              component: {
                render(c) { return c('router-view'); },
              },
              meta: {
                auth: true,
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
              children: [
                {
                  path: '',
                  name: 'MarketplacesMarketplaces',
                  component: Marketplaces,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
                {
                  path: ':marketplaceId',
                  component: MarketplaceContainer,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                  children: [
                    {
                      path: '',
                      name: 'MarketplaceMain',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplaceMain,
                    },
                    {
                      path: 'credential-fields',
                      name: 'MarketplaceCredentialFields',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplaceCredentialFields,
                    },
                    {
                      path: 'fields',
                      name: 'MarketplaceFields',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplaceFields,
                    },
                    {
                      path: 'templates',
                      name: 'MarketplaceTemplates',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplaceTemplates,
                    },
                  ],
                },
              ],
            },
            {
              path: 'categories',
              component: {
                render(c) { return c('router-view'); },
              },
              meta: {
                auth: true,
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
              children: [
                {
                  path: '',
                  name: 'MarketplacesCategories',
                  component: MarketplacesCategories,
                  meta: {
                    auth: true,
                    breadcrumbs: 'Categories',
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
                {
                  path: ':categoryId',
                  component: MarketplacesCategoryContainer,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                  children: [
                    {
                      path: '',
                      name: 'MarketplacesCategory',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplacesCategory,
                    },
                    {
                      path: 'templates',
                      name: 'MarketplacesCategoryTemplates',
                      meta: {
                        auth: true,
                        authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                      },
                      component: MarketplacesCategoryTemplates,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Users',
          path: 'users',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Users',
            authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
          },
          children: [
            {
              name: 'UsersAccounts',
              path: 'accounts',
              component: Accounts,
              meta: {
                auth: true,
                breadcrumbs: 'Accounts',
                authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
              },
              children: [
                {
                  name: 'UsersCreateAccount',
                  path: 'create',
                  component: CreateAccount,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
                  },
                },
                {
                  name: 'UsersEditAccount',
                  path: ':id',
                  component: EditAccount,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
                  },
                },
              ],
            },
            {
              name: 'UsersUsers',
              path: 'users',
              component: Users,
              meta: {
                auth: true,
                authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
              },
              children: [
                {
                  name: 'UsersCreateUser',
                  path: 'create',
                  component: CreateUser,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
                  },
                },
                {
                  name: 'UsersEditUser',
                  path: ':id',
                  component: EditUser,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
                  },
                },
              ],
            },
          ],
        },
        {
          name: 'Products',
          path: 'products',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            breadcrumbs: 'Products',
            authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          },
          children: [
            {
              name: 'ProductsColorsMaps',
              path: 'colors/maps',
              component: ProductsColorsMaps,
              meta: {
                auth: true,
                breadcrumbs: 'Colors Maps',
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
            },
            {
              name: 'ProductsSizesMaps',
              path: 'sizes/maps',
              component: ProductsSizesMaps,
              meta: {
                auth: true,
                breadcrumbs: 'Sizes Maps',
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
            },
          ],
        },
        {
          name: 'PlanManagement',
          path: 'plan-management',
          component: {
            render(c) {
              return c('router-view');
            },
          },
          meta: {
            auth: true,
            breadcrumbs: 'PlanManagement',
            authorize: [UsersRoleModel.ROLE_SUPERADMIN],
          },
          children: [
            {
              name: 'CustomPlanManagement',
              path: 'custom-plans',
              component: CustomPlans,
              meta: {
                auth: true,
                breadcrumbs: 'CustomPlanManagement',
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
              children: [
                {
                  name: 'CreateCustomPlan',
                  path: 'create',
                  component: CustomPlanCreate,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
                {
                  name: 'EditCustomPlan',
                  path: ':id',
                  component: CustomPlanEdit,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
              ],
            },
            {
              name: 'DefaultPlanManagement',
              path: 'default-plans',
              component: DefaultPlans,
              meta: {
                auth: true,
                breadcrumbs: 'DefaultPlanManagement',
                authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
              children: [
                {
                  name: 'CreateDefaultPlan',
                  path: 'create',
                  component: DefaultPlanCreate,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
                {
                  name: 'EditDefaultPlan',
                  path: ':id',
                  component: DefaultPlanEdit,
                  meta: {
                    auth: true,
                    authorize: [UsersRoleModel.ROLE_SUPERADMIN],
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'inventory-logs/:id',
          name: 'InventoryLogs',
          component: InventoryLogs,
          meta: {
            auth: true,
            breadcrumbs: 'InventoryLogs',
            // authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
          },
          children: [
            {
              name: 'InventoryLogsDetail',
              path: ':log_id',
              component: InventoryLogsDetail,
              meta: {
                auth: true,
                // authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
            },
          ],
        },
        {
          path: 'order-logs/:id',
          name: 'OrderLogs',
          component: OrderLogs,
          meta: {
            auth: true,
            breadcrumbs: 'OrderLogs',
            // authorize: [UsersRoleModel.ROLE_SUPERADMIN, UsersRoleModel.ROLE_SHIPNETWORK],
          },
          children: [
            {
              name: 'OrderLogsDetail',
              path: ':log_id',
              component: OrderLogsDetail,
              meta: {
                auth: true,
                // authorize: [UsersRoleModel.ROLE_SUPERADMIN],
              },
            },
          ],
        },
      ],
    },
    {
      path: '/admins',
      name: 'Admins',
      redirect: '/login',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [{
        path: '/login',
        name: 'Login',
        component: Login,
      }],
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view'); },
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Error404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Error500,
        },
      ],
    },
    {
      path: '*',
      redirect: '/pages/404',
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (UserTokenService.getToken() === null) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      if (to.meta.authorize) {
        const user = await AdminsService.profile();
        const authorized = user.roles.map(role => to.meta.authorize.includes(role.id)).includes(true);
        if (authorized) {
          next();
          // console.log('authorized');
        }
        else {
          return next({ path: '/' });
          // console.log('not authorized');
        }
      }
      next();
    }
  } else {
    next();
  }
});

export default router;
